import {DecimalPipe} from '@angular/common'
import {Component, computed, input} from '@angular/core'
import {MatCheckbox, MatCheckboxChange} from '@angular/material/checkbox'
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatFooterCell,
  MatFooterCellDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
  MatTableDataSource
} from '@angular/material/table'
import {IStatistics} from '../statistics.component'

@Component({
  selector: 'spb-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  imports: [
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatFooterCellDef,
    MatFooterCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    MatCheckbox,
    DecimalPipe
  ]
})
export class TableComponent {
  public range = input<string>('')
  public data = input<IStatistics[]>([])

  public hidePercent = false

  public processedData = computed(() => {
    const rangeValue = this.range()
    // Create a copy to avoid mutating the signal
    const data = [...this.data()]

    if (rangeValue === 'year' && data[1]) {
      return [data[1], data[0]]
    }

    // This has to be sorted "natural sort", however that is too complicated, so we cheat.
    if (rangeValue === 'age') {
      data.sort((a, b) => {
        const A = Number.parseInt(a.key, 10)
        const B = Number.parseInt(b.key, 10)
        if (A < B) {
          return -1
        }
        if (A > B) {
          return 1
        }
        return 0
      })
    }
    return data
  })

  public tableSource = computed(() => {
    return new MatTableDataSource<IStatistics>(this.processedData())
  })

  public rangeTitle = computed(() => {
    switch (this.range()) {
    case 'week':
      return 'Vecka'
    case 'month':
      return 'Månad'
    case 'year':
      return 'År'
    case 'weekday':
      return 'Veckodag'
    case 'day':
      return 'Dag'
    case 'sex':
      return 'Kön'
    case 'age':
      return 'Ålder'
    case 'all':
      return 'Alla'
    default:
      return 'Vecka'
    }
  })

  public columnsToDisplay = computed(() => {
    const columns = ['total', 'auto_total', 'approved', 'rejected', 'kalp', 'uc', 'pending', 'issuable', 'amount']
    const rangeValue = this.range()

    if (!rangeValue || rangeValue === 'all') {
      return columns
    }

    return [rangeValue, ...columns]
  })

  public getTotal(event: MatCheckboxChange | undefined, key: string) {
    if (key === 'percent' && event) {
      this.hidePercent = event.checked
    }
    return Number.parseInt(key, 10)
  }
}
